"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _actions = require('./actions');

/* "Templates" in the composer's + menu (lane D). Staff only, so a patient
 * never sees it. Each platform maps the id to opening its templates (the web
 * Templates dialog). Cmd/Ctrl+J opens it from the composer on web and
 * desktop; no label shows it, only aria-keyshortcuts. Cmd/Ctrl+T belongs to
 * the browser. */
 const TEMPLATES_COMPOSER_ACTION = {
  id: 'templates',
  label: 'Templates',
  icon: 'templates',
  section: 'insert',
  shortcut: { key: 'j', mod: true },
  platforms: ['web', 'desktop', 'mobile'],
  roles: ['staff'],
}; exports.TEMPLATES_COMPOSER_ACTION = TEMPLATES_COMPOSER_ACTION

let unregister = null

/* Registers the action once; later calls do nothing. */
 const registerTemplatesComposerAction = () => {
  unregister ??= _actions.registerComposerAction.call(void 0, exports.TEMPLATES_COMPOSER_ACTION)
}; exports.registerTemplatesComposerAction = registerTemplatesComposerAction
